/* Dog Owner's Guide + FAQ page behaviour.
   - Guide: "Show more guides" loads the next page of the list in place (falls back to a normal link).
   - FAQ: live search, section pills, one open question per group. */
(() => {
  // ---------- Guide: show more ----------
  document.addEventListener('click', async (event) => {
    const more = event.target.closest('[data-ck-guide-more]');
    if (!more || more.dataset.loading) return;
    const list = more.parentElement.querySelector('[data-ck-guide-list]');
    if (!list) return;
    event.preventDefault();
    more.dataset.loading = 'true';
    more.setAttribute('aria-busy', 'true');
    const url = new URL(more.href, window.location.origin);
    url.searchParams.set('section_id', more.dataset.sectionId);
    try {
      const response = await fetch(url.toString());
      if (!response.ok) throw new Error(response.status);
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      const nextList = doc.querySelector('[data-ck-guide-list]');
      const nextMore = doc.querySelector('[data-ck-guide-more]');
      const firstNew = nextList && nextList.querySelector('a');
      if (nextList) list.append(...nextList.children);
      if (nextMore) {
        more.href = nextMore.href;
        more.textContent = nextMore.textContent;
        delete more.dataset.loading;
        more.removeAttribute('aria-busy');
      } else {
        more.remove();
      }
      // Keep keyboard users in place: move focus to the first new guide.
      if (firstNew && document.activeElement === more) firstNew.focus();
    } catch (error) {
      window.location.href = more.href;
    }
  });

  // ---------- FAQ ----------
  const faq = document.querySelector('[data-ck-faq]');
  if (!faq) return;

  const input = faq.querySelector('[data-ck-faq-search]');
  const clear = faq.querySelector('[data-ck-faq-clear]');
  const empty = faq.querySelector('[data-ck-faq-empty]');
  const queryOut = faq.querySelector('[data-ck-faq-query]');
  const pills = [...faq.querySelectorAll('[data-ck-faq-pill]')];
  const groups = [...faq.querySelectorAll('[data-ck-faq-group]')];
  const items = [...faq.querySelectorAll('[data-ck-faq-item]')];
  const initiallyOpen = new Set(items.filter((item) => item.open));
  let activeGroup = '';

  const textOf = (item) => {
    if (!item._ckText) item._ckText = item.textContent.replace(/\s+/g, ' ').toLowerCase();
    return item._ckText;
  };

  const update = () => {
    const query = input ? input.value.trim().toLowerCase() : '';
    const terms = query.split(/\s+/).filter(Boolean);
    let shown = 0;

    groups.forEach((group) => {
      const id = group.dataset.ckFaqGroup;
      let matches = 0;
      group.querySelectorAll('[data-ck-faq-item]').forEach((item) => {
        const match = terms.every((term) => textOf(item).includes(term));
        item.hidden = !match;
        if (match) matches += 1;
        if (terms.length) item.open = match && matches === 1;
        else item.open = initiallyOpen.has(item);
      });
      const count = faq.querySelector(`[data-ck-faq-count="${id}"]`);
      if (count) count.textContent = terms.length ? matches : '';
      const visible = matches > 0 && (!activeGroup || activeGroup === id);
      group.hidden = !visible;
      if (visible) shown += matches;
    });

    if (clear) clear.hidden = !query;
    if (empty) {
      empty.hidden = shown > 0;
      if (queryOut) queryOut.textContent = input ? input.value.trim() : '';
    }
  };

  if (input) {
    input.addEventListener('input', update);
    input.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && input.value) {
        input.value = '';
        update();
      }
    });
  }
  if (clear) {
    clear.addEventListener('click', () => {
      input.value = '';
      update();
      input.focus();
    });
  }

  pills.forEach((pill) => {
    pill.addEventListener('click', () => {
      const id = pill.dataset.ckFaqPill;
      activeGroup = activeGroup === id ? '' : id;
      pills.forEach((p) => p.setAttribute('aria-pressed', String(p.dataset.ckFaqPill === activeGroup)));
      update();
    });
  });

  // One open question per group.
  items.forEach((item) => {
    item.addEventListener('toggle', () => {
      if (!item.open) return;
      const group = item.closest('[data-ck-faq-group]');
      if (!group) return;
      group.querySelectorAll('[data-ck-faq-item][open]').forEach((other) => {
        if (other !== item) other.open = false;
      });
    });
  });

  // Deep link: /pages/faq?q=puppies pre-fills the search.
  const preset = new URLSearchParams(window.location.search).get('q');
  if (input && preset) {
    input.value = preset;
    update();
  }
})();
